<template>
  <div class="donate_content_block">
    <div class="donate">
      <div class="donate_box" v-for="board in boardData" :key="`donate${board.wr_id}`" @click="goDetail(board.wr_id)">
        <div class="donate_box_img" :style="`background-image:url(${returnImage(board)})`"></div>
        <div class="donate_box_title">{{ board.wr_subject }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import imageOption from "@/mixins/imageOption";
import util from "@/mixins/util";

export default {
  name: "BoardListDonateLayout",
  mixins: [imageOption],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {
    boardData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {}
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    returnImage(board) {
      if (!util.isEmpty(board.File.MobileFile[0])) {
        return `${board.File.MobileFile[0].org_url}?${this.setImageOptions(316, 316, 'jpg')}`;
      }
    },
    goDetail(idx) {
      this.$router.push(`/donate/${idx}`)
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>